/**
 * State
 * @type {Object}
 */
const state = {
    data: {
        languages: [],
        specialization: [],
        clients: [],
        statusses: []
    }
}

/**
 * Getters
 * @type {Object}
 */
const getters = {}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    load({commit}) {

        this.$xhr.get('/api/preferences/').then( ( {result} ) => {
            commit('set', result);
        }).catch( () => {
            console.error('Can\'t load preferences');
        });
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

    set(state, result) {
        state.data = result;
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
